import { BehaviorSubject } from 'rxjs';

export default class DownloadBloc {
  downloadLink$ = new BehaviorSubject(null);
  isLoading$ = new BehaviorSubject(false);
  error$ = new BehaviorSubject(false);

  constructor({ patientRepository }) {
    this.patientRepository = patientRepository;
  }

  async getDownloadLink(resourceId, token) {
    try {
      this.isLoading$.next(true);
      const response = await this.patientRepository.getDownloadCompressedStudyLink(resourceId, token);
      const { downloadLink } = response;
      await new Promise((resolve) => setTimeout(() => resolve(), 2000));
      this.downloadLink$.next(downloadLink);
    } catch (error) {
      this.error$.next(true);
    } finally {
      this.isLoading$.next(false);
    }
  }
}
